import { PlayerControlsDefinitions } from '../../PlayerControlTypes/types';
import { ControlsBackgroundType } from './../../components/ControlsBackground';

export const defaultControls: PlayerControlsDefinitions = {
  backgroundType: 'solid' as ControlsBackgroundType,
  basicInfo: true,
  dismiss: false,
  fullscreen: false,
  hotkeys: true,
  showBrandLogo: false,
  skipBackward: true,
  skipForward: true,
  timeline: false,
  volume: true,
  settings: false,
};
